import * as actions from '../actions/types'

const initialState = {
  applicationPeriods: [],
  application: {},
  applicationSet: false,
  alerts: [],
  isInvoking: false,
  invokingMessage: "",
  newUser: false,
  applicationUpdated: false
};

function updateApplicationPeriods(appState, action) {
  return {
    ...appState,
    ...action.updates
  };
}

function setApplicationPeriods(appState, action) {
  // Mark fetch successful. periods should probably be moved out of app info
  const newState = invokeResponse(appState);
  return {
    ...newState,
    applicationPeriods: action.periods
  };
}

function setApplication(appState, action) {
  return {
    ...appState,
    application: action.application,
    applicationSet: true,
    applicationUpdated: false
  }
}

function addAlert(appState, action) {
  return {
    ...appState,
    alerts: [
      ...appState.alerts,
      action.alert
    ]
  }
}

function removeAlert(appState, action) {
  return {
    ...appState,
    alerts: appState.alerts.filter(alert => action.id !== alert.id)
  }
}

function invokeRequest(appState, action) {
  return {
    ...appState,
    isInvoking: true,
    invokingMessage: action.type
  }
}

function invokeResponse(appState) {
  return {
    ...appState,
    isInvoking: false,
    invokingMessage: ''
  }
}

function setNewUser(appState, action) {
  return {
    ...appState,
    newUser: action.newUser
  }
}

function setUser(appState, action) {
  return {
    ...appState,
    newUser: !action.user.complete
  }
}

function applicationUpdated(appState) {
  return {
    ...appState,
    applicationUpdated: true
  }
}

function applicationClean(appState) {
  return {
    ...appState,
    applicationUpdated: false
  }
}

function applicationDeleted(appState) {
  const newState = invokeResponse(appState);
  return {
    ...newState,
    applicationSet: false,
    applicationUpdated: false,
    application: {}
  }
}

// TODO: Add invoking handling to different APIs to handle overlap
export const appInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.UPDATE_APPLICATION_PERIODS:
      return updateApplicationPeriods(state, action);
    case actions.SET_APPLICATION_PERIODS:
      return setApplicationPeriods(state, action);
    case actions.SET_APPLICATION:
    case actions.REFRESH_APPLICATION:
      return setApplication(state, action);
    case actions.ADD_ALERT:
      return addAlert(state, action);
    case actions.REMOVE_ALERT:
      return removeAlert(state, action);
    case actions.FETCH_USER_REQUEST:
    case actions.CREATE_USER_REQUEST:
    case actions.CREATE_APPLICATION_REQUEST:
    case actions.FETCH_APPLICATION_REQUEST:
    case actions.FETCH_PERIODS_REQUEST:
    case actions.DELETE_APPLICATION_REQUEST:
    case actions.UPDATE_APPLICATION_STATUS_REQUEST:
    case actions.UPDATE_APPLICATION_REQUEST:
    case actions.SUBMIT_APPLICATION_REQUEST:
      return invokeRequest(state, action);
    case actions.FETCH_USER_SUCCESS:
    case actions.FETCH_USER_FAILURE:
    case actions.USER_NOT_FOUND:
    case actions.CREATE_USER_SUCCESS:
    case actions.CREATE_USER_FAILURE:
    case actions.CREATE_APPLICATION_SUCCESS:
    case actions.CREATE_APPLICATION_FAILURE:
    case actions.FETCH_APPLICATION_SUCCESS:
    case actions.FETCH_APPLICATION_FAILURE:
    case actions.APP_ALREADY_SET:
    case actions.FETCH_PERIODS_FAILURE:
    case actions.DELETE_APPLICATION_FAILURE:
    case actions.UPDATE_APPLICATION_STATUS_SUCCESS:
    case actions.UPDATE_APPLICATION_STATUS_FAILURE:
    case actions.UPDATE_APPLICATION_SUCCESS:
    case actions.UPDATE_APPLICATION_FAILURE:
    case actions.SUBMIT_APPLICATION_SUCCESS:
    case actions.SUBMIT_APPLICATION_FAILURE:
      return invokeResponse(state, action);
    case actions.FETCH_PERIODS_SUCCESS:
      return setApplicationPeriods(state, action);
    case actions.SET_NEW_USER:
      return setNewUser(state, action);
    case actions.SET_USER:
      return setUser(state, action);
    case actions.UPDATE_BASIC_INFO:
    case actions.UPDATE_PROFESSIONAL_INFO:
    case actions.UPDATE_CERTIFICATE:
    case actions.UPDATE_EDUCATION_INFO:
    case actions.UPDATE_COLLEGE:
    case actions.UPDATE_DEGREE:
    case actions.UPDATE_LICENSE:
    case actions.UPDATE_OTHER_INFO:
    case actions.UPDATE_TEAS:
    case actions.UPDATE_COURSE:
    case actions.TOGGLE_UPGRADE_OPTION:
    case actions.SET_UPGRADE_OPTION:
    case actions.UPDATE_PT_REQUIREMENTS_INFO:
      return applicationUpdated(state, action);
    case actions.UPDATE_APPLICATION_SUCCESS:
      return applicationClean(state, action);
    case actions.DELETE_APPLICATION_SUCCESS:
      return applicationDeleted(state, action);
    default: return state;
  }
};

export default appInfoReducer;